
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chefs",
      function () {
        return require("private-next-pages/chefs/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chefs"])
      });
    }
  